// A pallet id shown so the part that TELLS PALLETS APART stays visible.
//
// Pallet ids are `<PREFIX>-<YEAR>-<serial>` (generate_pallet_id, mig 1043):
// KF49-2026-00417. The prefix and year are the same on every pallet of the
// season; only the serial differs. Twelve screens used to show
// `pallet_id.slice(0, 8)` — "KF49-202…" — so every card on a truck manifest, a
// coldroom cell or a delivery read the same (packhouse audit PM-SH-15 / PW-09).
// Plain `truncate` is no better: it cuts from the right, which is the serial.
//
// So: show the whole id, and when the space is too narrow for it, trim from
// the LEFT. The box runs right-to-left, which puts the ellipsis at the start;
// the id inside is a <bdi>, so it still reads left-to-right. The full id is
// always in `title`.
import clsx from 'clsx'

export default function PalletIdText({ id, className }: {
  id: string
  /** Colour / size classes; layout (truncation, direction) is this component's. */
  className?: string
}) {
  return (
    <span title={id}
      className={clsx('inline-block max-w-full align-bottom truncate text-left font-mono tabular-nums [direction:rtl]', className)}>
      <bdi>{id}</bdi>
    </span>
  )
}
